import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { getPlannedWorkLabel } from '../../../../Sections/labels';
import { PlannedWork } from '../../../../Sections/properties';
import asSyncChoiceField from '../../asSyncChoiceField';
import SyncChoiceDiffOptionRows from '../../Base/Input/SyncChoiceDiffOptionRows';
import SyncChoiceIdenticalRow from '../../Base/Input/SyncChoiceIdenticalRow';
import SyncInputGroup from '../../Base/Input/SyncInputGroup';
import { isIdenticalValue } from '../../equals';
import { validateListChoiceComplete } from '../../validation';
import { getDiffPlannedWorkOptionRows, getIdenticalPlannedWorkOptionRows } from './functions';

const PlannedWorksSyncChoice = ({ planValue, liveValue, value: currentFormValue, onChange, showIdentical }) => {

    const onSelect = (selectedValue) => {
        const newValue = {
            ...currentFormValue,
            ...selectedValue
        };

        onChange(newValue);
    };

    const renderPlannedWorkLabel = (value) => {

        if (!value) {
            return '-';
        }

        const valueKey = Object.keys(value)[0];

        // Sonstiges
        if (valueKey === PlannedWork.Other) {

            if (value[valueKey] === false) {
                return '-';
            }

            return `Sonstiges: ${value[valueKey]}`;
        }

        // Not set
        if (value[valueKey] === false) {
            return '-';
        }

        return getPlannedWorkLabel(Object.keys(value)[0]);

    };

    const isSelected = (value) => {

        if (!currentFormValue || !value) {
            return false;
        }

        const key = value ? Object.keys(value)[0] : undefined;
        if (!key) {
            return false;
        }

        return currentFormValue[key] === value[key];

    };

    const renderIdenticalRows = () => {
        if (_.isEmpty(planValue) && _.isEmpty(liveValue)) {
            return (
                <SyncChoiceIdenticalRow
                    key="planned-work"
                    leftValue={'-'}
                    rightValue={'-'}
                    renderValue={a => a}
                    showIdentical={showIdentical}
                />
            );
        }

        const identicalOptionRows = getIdenticalPlannedWorkOptionRows(planValue, liveValue);
        if (_.isEmpty(identicalOptionRows)) {
            return null;
        }

        return identicalOptionRows.map(optionRow => (
            <SyncChoiceIdenticalRow
                key={optionRow.key}
                leftValue={optionRow.left}
                rightValue={optionRow.right}
                renderValue={renderPlannedWorkLabel}
                showIdentical={showIdentical}
            />
        ));
    };

    const isIdentical = isIdenticalValue(planValue, liveValue);
    if (isIdentical && !showIdentical) {
        return null;
    }

    return (
        <SyncInputGroup
            label="Geplante Arbeiten"
        >
            {showIdentical && renderIdenticalRows()}
            <SyncChoiceDiffOptionRows
                planValue={planValue}
                liveValue={liveValue}
                getOptionRows={getDiffPlannedWorkOptionRows}
                renderValue={renderPlannedWorkLabel}
                onSelect={onSelect}
                isSelected={isSelected}
            />
        </SyncInputGroup>
    );
};

PlannedWorksSyncChoice.propTypes = {
    planValue: PropTypes.object,
    liveValue: PropTypes.object,
    value: PropTypes.any,
    onChange: PropTypes.func,
    showIdentical: PropTypes.bool
};

PlannedWorksSyncChoice.defaultProps = {
    planValue: null,
    liveValue: null,
    value: null,
    onChange: () => false
};

export default asSyncChoiceField(PlannedWorksSyncChoice, {
    allowNull: true,
    validate: validateListChoiceComplete()
});
